var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { BaseQuery, UPDATE } from './BaseQuery.js';
import { findPageOfOids } from './dbQueries.js';
import { areIndexesEqual } from './utils.js';
export class FindInfiniteQuery extends BaseQuery {
    get pageSize() {
        return this._pageSize;
    }
    get hasMore() {
        return this._hasNextPage;
    }
    constructor(_b) {
        var { hydrate, pageSize, index } = _b, rest = __rest(_b, ["hydrate", "pageSize", "index"]);
        super(Object.assign({ initial: [] }, rest));
        this._upToPage = 1;
        this._hasNextPage = false;
        this.run = async () => {
            const { result, hasNextPage } = await findPageOfOids({
                collection: this.collection,
                context: this.context,
                limit: this._pageSize * this._upToPage,
                offset: 0,
                index: this.index,
            });
            this._hasNextPage = hasNextPage;
            this.setValue(await Promise.all(result.map(this.hydrate)));
        };
        this.loadMore = async () => {
            const { result, hasNextPage } = await findPageOfOids({
                collection: this.collection,
                context: this.context,
                limit: this._pageSize,
                offset: this._pageSize * this._upToPage,
                index: this.index,
            });
            this._hasNextPage = hasNextPage;
            this._upToPage++;
            this.setValue([
                ...this.current,
                ...(await Promise.all(result.map(this.hydrate))),
            ]);
        };
        this[_a] = (index) => {
            if (areIndexesEqual(this.index, index))
                return;
            this.index = index;
            this.execute();
        };
        this.index = index;
        this.hydrate = hydrate;
        this._pageSize = pageSize;
    }
}
_a = UPDATE;
//# sourceMappingURL=FindInfiniteQuery.js.map